import Submenu from './submenu';

export default Submenu;
